import "normalize.css";
import "../_css/main.scss";
import "@fortawesome/fontawesome/styles.css";
import React, { useRef, useState } from "react";
import { animated, useTransition } from "react-spring";
import { useCookies } from "react-cookie";
import Header from "../Header";
import Footer from "../Footer";
import Chatbot from "../Chatbot";
import CookieConsent from "../CookieConsent";
import IPLocationDetector from "../IPLocationDetector";
import { isTLD } from "../../helperFunctions";

const { Provider: LocaleProvider, Consumer: LocaleConsumer } = React.createContext({});
const ChatbotState = React.createContext({});
const ZChatInitState = React.createContext({});
const Cookie = React.createContext({});
const HeroSectionState = React.createContext({});
const UserIPLocation = React.createContext({});
const ActiveCountry = React.createContext({});

// TO DO:
// Put default locale if locale props not defined.

const Layout = ({
  children,
  locale,
  alias,
  htmlLang,
  location,
  variant,
  emptyLayout
}) => {
  const [heroSectionValue, setHeroSectionValue] = useState(null);
  const zChatInitialState = useRef(false);
  const [isHeroSectionUsed, setHeroSectionUsed] = useState(false);
  const [cookie, setCookie] = useCookies(["userId", "chatbot"]);
  const [userIPLocation, setUserIPLocation] = useState(null);
  const [userIPLocationCode, setUserIPLocationCode] = useState(null);
  const notProd = process.env.GATSBY_ACTIVE_ENV !== "production";
  const [active, setActive] = useState({
    key: 0,
    country: "Singapore"
  });
  const [arrowPosition, setArrowPosition] = useState(0);
  const [activeIndexMobile, setActiveIndexMobile] = useState(0);
  const [chatbotOpen, setChatbotOpen] = useState(false);
  const config = { mass: 1, tension: 2000, friction: 100 };
  const transitions = useTransition(chatbotOpen, null, {
    config,
    enter: { opacity: 1, transform: "scale(1)" },
    leave: { opacity: 0, transform: "scale(0.96)" }
  });

  const chatbotWrapper = transitions.map(({ item, key, props }) => {
    return (
      item && (
        <animated.div
          style={{
            ...props,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9997
          }}
          key={key}
        >
          <Chatbot initialMessage={heroSectionValue} />
        </animated.div>
      )
    );
  });

  return (
    <LocaleProvider value={{ locale, alias, htmlLang }}>
      <UserIPLocation.Provider
        value={{
          userIPLocation,
          setUserIPLocation,
          userIPLocationCode,
          setUserIPLocationCode
        }}
      >
        <HeroSectionState.Provider value={{ isHeroSectionUsed, setHeroSectionUsed }}>
          <ChatbotState.Provider
            value={{
              chatbotOpen,
              setChatbotOpen,
              heroSectionValue,
              setHeroSectionValue
            }}
          >
            <ZChatInitState.Provider value={{ zChatInitialState }}>
              <Cookie.Provider value={{ cookie, setCookie }}>
                <ActiveCountry.Provider
                  value={{
                    active,
                    setActive,
                    arrowPosition,
                    setArrowPosition,
                    activeIndexMobile,
                    setActiveIndexMobile
                  }}
                >
                  <div className="wrapper">
                    {notProd ? null : null}
                    {!emptyLayout && (
                      <Header location={location} variant={variant} locale={locale} />
                    )}
                    <div style={{ minHeight: "100vh" }}>{children}</div>
                    {!emptyLayout && (
                      <Footer variant={variant} locale={locale} alias={alias} />
                    )}
                    <CookieConsent locale={locale} />
                    {!isTLD("cn") && <IPLocationDetector />}
                  </div>
                </ActiveCountry.Provider>
              </Cookie.Provider>
            </ZChatInitState.Provider>
          </ChatbotState.Provider>
        </HeroSectionState.Provider>
      </UserIPLocation.Provider>
    </LocaleProvider>
  );
};

export default Layout;

export {
  LocaleConsumer,
  ChatbotState,
  ZChatInitState,
  Cookie,
  HeroSectionState,
  UserIPLocation,
  ActiveCountry
};
